import React, { useState } from 'react';
import { Camera, Loader2, X } from 'lucide-react';
import ImagemSharePoint from './ImagemSharePoint';

// =====================================================================
// Fotos de UM item da inspeção de Conservação Predial.
//
// Diferença para o FotoUpload da Certificação: lá cada slot guarda UMA foto
// (são 6 ângulos nomeados e fixos); aqui o item aceita VÁRIAS — a
// especificação pede "Múltiplas Fotos" por item, porque um problema de
// fachada ou de rejunte raramente cabe num único ângulo.
//
// Cada foto sobe na hora (POST /upload-foto → SharePoint) e o componente
// devolve ao pai só o array de URLs. O upload separado (em vez de base64 no
// submit) é o que impede o payload de uma inspeção de 90 itens de estourar.
// =====================================================================

const API = '/api/manutencao/conservacao';
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem('authToken')}` });

const FotosItem = ({ fotos = [], onChange, loja, area, max = 5, obrigatoria = false }) => {
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState('');

  const cheio = fotos.length >= max;

  // Envia em sequência (não em paralelo): o celular do especialista costuma
  // estar em rede fraca, e 5 uploads simultâneos falham mais do que 5 em fila.
  const enviar = async (arquivos) => {
    const lista = Array.from(arquivos || []).slice(0, max - fotos.length);
    if (lista.length === 0) return;
    setEnviando(true); setErro('');
    const novas = [];
    try {
      for (const file of lista) {
        const fd = new FormData();
        fd.append('foto', file);
        if (loja) fd.append('loja', loja);
        if (area) fd.append('area', area);
        const r = await fetch(`${API}/upload-foto`, { method: 'POST', headers: auth(), body: fd });
        const data = await r.json();
        if (!r.ok) throw new Error(data?.message || 'Falha no upload.');
        novas.push(data.url);
      }
      onChange([...fotos, ...novas]);
    } catch (e) {
      // Preserva o que já subiu antes do erro — refazer o upload das fotos
      // que deram certo seria castigo desnecessário numa rede ruim.
      if (novas.length > 0) onChange([...fotos, ...novas]);
      setErro(e.message || 'Erro ao enviar.');
    } finally {
      setEnviando(false);
    }
  };

  const remover = (url) => onChange(fotos.filter((f) => f !== url));

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 6 }}>
      {fotos.map((url) => (
        <span key={url} style={{ position: 'relative', display: 'inline-block' }}>
          {/* Proxy: a webUrl do SharePoint é autenticada e não carrega direto. */}
          <ImagemSharePoint url={url} alt="Foto do item" size={52} borderColor="#c7d2fe" />
          <button type="button" onClick={() => remover(url)} title="Remover foto"
            style={{
              position: 'absolute', top: -6, right: -6, width: 20, height: 20, padding: 0,
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
              borderRadius: '50%', border: '1px solid #fecaca', background: '#fef2f2',
              color: '#b91c1c', cursor: 'pointer', lineHeight: 0,
            }}>
            <X size={12} />
          </button>
        </span>
      ))}

      {!cheio && (
        <label style={{
          display: 'inline-flex', alignItems: 'center', gap: 6, cursor: enviando ? 'wait' : 'pointer',
          padding: '6px 10px', borderRadius: 6, fontSize: 12, fontWeight: 700,
          border: '1px dashed', borderColor: obrigatoria && fotos.length === 0 ? '#fca5a5' : '#cbd5e1',
          background: obrigatoria && fotos.length === 0 ? '#fef2f2' : '#fff',
          color: obrigatoria && fotos.length === 0 ? '#b91c1c' : '#475569',
        }}>
          {enviando ? <Loader2 size={14} className="spin" /> : <Camera size={14} />}
          {enviando ? 'Enviando…' : fotos.length === 0 ? 'Foto' : '+ Foto'}
          {/* multiple: o especialista costuma fotografar o mesmo problema de
              vários ângulos de uma vez. Sem `capture`, o celular oferece as
              duas opções (câmera ou galeria). */}
          <input type="file" accept="image/*" multiple style={{ display: 'none' }} disabled={enviando}
            onChange={(e) => { enviar(e.target.files); e.target.value = ''; }} />
        </label>
      )}

      {erro && <span style={{ fontSize: 11, color: '#b91c1c', fontWeight: 700 }}>{erro}</span>}
    </div>
  );
};

export default FotosItem;
